import React from "react";
import {
  FaGraduationCap,
  FaCertificate,
  FaMicrosoft,
  FaRobot,
  FaUsers,
} from "react-icons/fa";
import { SiJavascript, SiFigma } from "react-icons/si";
import profile from "../../data/profile";

const certIcons = {
  FaMicrosoft: <FaMicrosoft style={{ color: "#3b82f6" }} />,
  FaRobot: <FaRobot style={{ color: "#10b981" }} />,
  SiJavascript: <SiJavascript style={{ color: "#f59e0b" }} />,
  SiFigma: <SiFigma style={{ color: "#f43f5e" }} />,
  FaUsers: <FaUsers style={{ color: "#8b5cf6" }} />,
};

function EduCerts() {
  return (
    <div className="education-grid">
      <section className="glass-card">
        <h2 className="section-title">
          <FaGraduationCap /> Education
        </h2>
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          {profile.education.map((edu, i) => (
            <div className="edu-item" key={i}>
              <span className="time-badge">{edu.badge}</span>
              <h4>{edu.degree}</h4>
              <p>{edu.institution}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="glass-card">
        <h2 className="section-title">
          <FaCertificate /> Certifications
        </h2>
        {profile.certifications.map((cert, i) => (
          <div className="cert-item" key={i}>
            {certIcons[cert.icon]}
            {cert.name}
          </div>
        ))}
      </section>
    </div>
  );
}

export default EduCerts;